/**
 * How a campaign reads on screen, from the `campaigns` map the server sends with every
 * Analytics response (key → { label, kind, id }). The server decides the name
 * (functions/handlers/campaignNaming.js); this only chooses what to print.
 */

/** "…480498" — the tail of a long id, which is what people recognise it by. */
export const tail = (id, n = 6) => (id && id.length > n + 2 ? `…${id.slice(-n)}` : id);

export function campaignDisplay(key, campaigns) {
  if (!key) return { label: 'No campaign tag', sub: null, kind: 'none' };
  const c = campaigns && campaigns[key];
  if (!c) return { label: key, sub: null, kind: 'text' };
  if (c.kind === 'named') return { label: c.label, sub: c.id && c.id !== c.label ? c.id : null, kind: 'named' };
  if (c.kind === 'opaque') return { label: `Meta campaign ${tail(key)}`, sub: key, kind: 'opaque' };
  return { label: c.label || key, sub: null, kind: 'text' };
}
